<script>
import Rule from '../index';
export default {
  extends: Rule,
  computed: {
    placeName() {
      return '第三期';
    }
  },
  methods: {
    async initPermission() {
      this.$login.teacherPermitted();
    }
  }
};
</script>
